import { SmartOLTOltSettingsPage } from "./SmartOLTOltSettingsPage.tsx"

export function SmartOLTOltsPage() {
  return <SmartOLTOltSettingsPage title="OLTs" subtitle="Optical line terminals in your network" />
}
